module.exports = __webpack_public_path__ + "static/media/aceN Logo_old.b74ebdb0.png";